<template>
    <LayoutSub :parent="this.$route.path?.split('/')[2]" className="point">
        <SubpageTitleContainer :title="`이지포캣(EasyPocat)`"
            :subText="`단말기 또는 POS가 설치된 매장에서 이용할 수 있는 고객관리 서비스입니다.<br />고객은 터치 한 번으로 빠르게, 매장은 ONE-STOP 상품/매출정보 연동으로 편리하게 이용 가능합니다.`">
            <!-- <RedLineButton type="inbound" text="부가서비스" /> -->
            <!-- <RedLineButton type="inbound" text="자료 다운로드" /> -->
        </SubpageTitleContainer>

        <SubSection class="pt-0">
            <RedTitleRow title="POS 사용 매장">
                <li>
                    <div class="text_area">
                        <p>결제 단계에서 고객이 POS 듀얼 스크린에 휴대폰 번호를 입력하여 본인 조회 후 포인트/스탬프를 적립하고 사용할 수 있습니다.</p>
                    </div>
                </li>
            </RedTitleRow>
            <RedTitleRow title="카드단말기 사용 매장">
                <li>
                    <div class="text_area">
                        <p>
                            단말기 설정에 따라 신용카드 결제 시 휴대폰번호/카드번호를 입력하거나 단말기의 "포인트" 버튼으로 이지포캣 메뉴에 접속하여
                            포인트를 적립하고 사용할 수 있습니다.
                        </p>
                    </div>
                </li>
            </RedTitleRow>
            <p class="list_under_text">
                * 이지포캣 서비스 사용을 원하는 경우 포인트 가맹점 설정을 필수로 진행해야 하며 이지포캣 관리자 웹사이트에서 손쉽게 거래내역 확인
                및 관리가 가능합니다.
            </p>
        </SubSection>

        <SubSection class="p-0">
            <SubTitle3 listStyle="dot">기능</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid src="point_ic_1.png" title="스탬프 적립/사용 및 고객 관리 가능" />
                <TableRow_2grid src="point_ic_2.png" title="신규 고객 웰컴쿠폰, 생일쿠폰 자동 발송" />
                <TableRow_2grid src="point_ic_3.png" title="연령대/고객별 인기상품 분석 등 상세리포트 제공" />
            </div>
            <div class="image_banner">
                <p class="title">이지포캣 가맹점용 웹사이트 운영</p>
                <p class="desc">
                    매장 자체 홈페이지가 없어도 고객의 포인트 현황, 사용 내역 등을 편하게 조회할 수 있는 웹사이트를 운영하고 있습니다. <br />
                    자체 홈페이지가 있는 가맹점은 홈페이지에서 포인트 조회가 가능하도록 기술 지원이 가능합니다.
                </p>
                <a href="https://www.easy-pocat.co.kr/" target="_blank">바로가기</a>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
// import RedLineButton from '@/components/RedLineButton.vue';
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        // RedLineButton,
        TableRow_2grid,
        RedTitleRow,
    },
};
</script>
